/** Define all validation rules separated by feature */
export namespace ValidationRuleEnum {
  export const global = Object.freeze({
    required: {
      message: 'This is a required field',
    },
    maxLength: {
      value: 100,
      message: 'Please enter not more than 100 digits',
    },
  });

  export const email = Object.freeze({
    required: {
      message: 'This is a required field',
    },
    pattern: {
      // eslint-disable-next-line max-len
      value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: 'Invalid email',
    },
  });

  export const reservationNo = Object.freeze({
    required: {
      message: 'This is a required field',
    },
  });

  export const password = Object.freeze({
    common: {
      message: 'At least 8 digits, with 1 upper case, 1 lower case, 1 number and 1 special character',
    },
    required: {
      message: 'This is a required field',
    },
    minLength: {
      value: 8,
      message: 'At least 8 digits, with 1 upper case, 1 lower case, 1 number and 1 special character',
    },
    pattern: {
      value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
      message: 'Please enter valid password',
    },
  });

  export const role = Object.freeze({
    required: {
      message: 'Role is required',
    },
  });

  export const course = Object.freeze({
    required: {
      message: 'This is a required field',
    },
    name: {
      maxLength: {
        value: 120,
        message: 'Course name exceed 120 digits',
      },
    },
    price: {
      min: {
        value: 1,
        message: 'Invalid price',
      },
    },
    uprankCoin: {
      min: {
        value: 0,
        message: 'Invalid uprank coin',
      },
    },
    quantityLimit: {
      min: {
        value: 1,
        message: 'Invalid quantity limit',
      },
    },
    quantityRestrict: {
      min: {
        value: 1,
        message: 'Invalid quantity restrict',
      },
    },
  });

  export const product = Object.freeze({
    required: {
      message: 'This is a required field',
    },
    name: {
      maxLength: {
        value: 120,
        message: 'Name is exceed 120 digits',
      },
    },
    code: {
      maxLength: {
        value: 20,
        message: 'Code is exceed 20 digits',
      },
    },
    highlighted: {
      maxLength: {
        value: 240,
        message: 'Highlighted is exceed 240 digits',
      },
    },
    quantityLimit: {
      min: {
        value: 1,
        message: 'Invalid quantity limit',
      },
    },
    quantityRestrict: {
      min: {
        value: 1,
        message: 'Invalid quantity restrict',
      },
    },
  });

  export const transactionNote = Object.freeze({
    required: {
      message: 'Note cannot be empty',
    },
  });

  export const accountDetailNote = Object.freeze({
    maxLength: {
      value: 255,
      message: 'Please enter not more than 255 digits',
    },
  });

  export const notification = Object.freeze({
    required: {
      message: 'You can\'t leave this empty',
    },
    title: {
      maxLength: {
        value: 100,
        message: 'Title is exceed 100 characters',
      },
    },
    message: {
      maxLength: {
        value: 500,
        message: 'Message is exceed 500 characters',
      },
    },
  });
  export const chatInformation = Object.freeze({
    required: {
      message: 'You can\'t leave this empty',
    },
    username: {
      maxLength: {
        value: 100,
        message: 'Username is exceed 100 characters',
      },
    },
    note: {
      required: {
        message: 'This is a required field',
      },
      maxLength: {
        value: 500,
        message: 'Note is exceed 500 characters',
      },
    },
  });

  export const nonAppVoucher = Object.freeze({
    required: {
      message: 'This field is required',
    },
  });
}
